import * as HttpService from "./http.service";
import { GET_DYNAMIC_LINK, GET_DYNAMIC_LINK_V1 } from "./url.service";

export const getDynamicUrl = (data) => {
    return HttpService.postWithOutAuth((GET_DYNAMIC_LINK()), data);
};

export const getDynamicUrlV1 = (data) => {
    return HttpService.postWithOutAuth((GET_DYNAMIC_LINK_V1()), data);
};